import {Menu} from "react-admin";
import {WineIcon} from "../icons/WineIcon";

export const CustomMenu = () => (
  <Menu>
    <Menu.ResourceItem name="admin/users"/>
    <Menu.Item to="/wine-suggestions" primaryText="Wine Suggestions" leftIcon={<WineIcon width={24} height={24}/>} />
  </Menu>
);
